module.exports = __webpack_public_path__ + "static/img/teacher_female.16c59cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher_female.png
// module id = +tXJ
// module chunks = 9